import { render } from "./questions.vue?vue&type=template&id=79749a10&scoped=true&ts=true"
import script from "./questions.vue?vue&type=script&lang=ts"
export * from "./questions.vue?vue&type=script&lang=ts"

import "./questions.vue?vue&type=style&index=0&id=79749a10&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79749a10"]])

export default __exports__